import _slicedToArray from "/codebuild/output/src343154253/src/AWSAmplifyTest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as t from "react";
import { useLayoutEffect as o } from "./useLayoutEffect.js";
var r = "amplify-id",
  e = t["useId".toString()] || function () {};
var i = 0;
var s = function s(r) {
  var _t$useState = t.useState(e()),
    _t$useState2 = _slicedToArray(_t$useState, 2),
    s = _t$useState2[0],
    n = _t$useState2[1];
  return o(function () {
    r || n(function (t) {
      return null != t ? t : String(i++);
    });
  }, [r]), r || (s ? "amplify-id-".concat(s) : "");
};
export { r as AUTO_GENERATED_ID_PREFIX, s as useStableId };